module.exports = __webpack_public_path__ + "img/ManagedService-head.d8521b4.png";